import { render } from "./ComparisonReportPage.vue?vue&type=template&id=37fb95c0&scoped=true&ts=true"
import script from "./ComparisonReportPage.vue?vue&type=script&lang=ts"
export * from "./ComparisonReportPage.vue?vue&type=script&lang=ts"

import "./ComparisonReportPage.vue?vue&type=style&index=0&id=37fb95c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37fb95c0"]])

export default __exports__